// removed by extract-text-webpack-plugin
module.exports = {"loader":"general__loader___2CseQ animation-spin borderRadius-circle borderStyle-solid display-block transitionDuration-m transitionProperty-opacity transitionTimingFunction-ease-in-out"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-loader/Loader/style/general.css
// module id = 9
// module chunks = 0 1 2 10 19